import React from 'react'
import CommonPayment from './CommonPayment';
import { PROD } from '../../common/constants';

function RoyaltyPayment() {
  
  return (
    <div>
      {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>PAY03</p>}
      <CommonPayment paymentType="Royalty"/>
    </div>
  )
}

export default RoyaltyPayment;